import React, { useEffect, useContext } from 'react';
import Context from '../../../context/appContext';
import 'antd/dist/antd.css';
import moment from 'moment';
import 'moment/locale/es-mx';
import { DatePicker, Form } from 'antd';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { DownOutlined } from "@ant-design/icons";
// @styles 
import './styles.scss'

export default function DatePickerComponent({ info, form, key }) {
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm } = useContext(Context);
    const validate = info.validate ? info.validate : {};

    useEffect(() => {
        getDefaultValue();
        if (formResponses.findIndex(x => x.key === info.key) == -1 && info.calculateValue)
            formResponses.push(info);
    }, []);

    const getDefaultValue = () => {
        let value = '';
        if (info.customDefaultValue) {
            const item = formResponses.find((x) => x.key === info.customDefaultValue);
            value = item && item.value ? item.value : '';
            disabledFields[info.key] = true;
            setDataForm({ data, formResponses, hiddenFields, disabledFields: disabledFields });
        } else if (info && info.defaultDate) {
            value = moment(eval(info.defaultDate));
        } else if (info && info.value && info.value !== null && info.value !== '') {
            value = info.value;
        }

        if (value && value !== '') {
            form.setFieldsValue({ [info.key]: value });
            onChange(value);
        }
    }

    const disabledDate = (current) => {
        const datePickerInfo = info && info.datePicker ? info.datePicker : {};
        return datePickerInfo.maxDate && current > moment().add(datePickerInfo.maxDate, 'days') ||
            datePickerInfo.minDate && current < moment().subtract(datePickerInfo.minDate, "days").endOf('day');
    }

    const onChange = (value) => {
        setValue(value ? moment(value).format(info.format ? info.format : "YYYY-MM-DD") : null);
    }

    const setValue = (value) => {
        info.value = value;
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(info);
        calculateValue();
    }

    const calculateValue = () => {
        const fieldsCalculated = formResponses.filter((item) => item.calculateValue && item.type === info.type);
        fieldsCalculated && fieldsCalculated.forEach(element => {
            let operation = element.calculateValue.operation;
            const calculateValueFields = element.calculateValue.fields;
            calculateValueFields && calculateValueFields.length > 0 && calculateValueFields.forEach(field => {
                const fieldInfo = formResponses.find((value) => value.key === field);
                const regex = new RegExp(field, 'ig');
                const newValue = moment(fieldInfo.value, info.format).format('YYYY-MM-DD HH:mm');
                operation = operation.replace(regex, fieldInfo && newValue);
            });
            if (operation) {
                try {
                    const index = formResponses.findIndex(x => x.key === element.key);
                    const result = eval(operation);
                    formResponses[index].value = moment(result).format('DD/MM/YYYY');
                    form.setFieldsValue({ [formResponses[index].key]: moment(result) });
                } catch (error) { }
            }
        });
    }

    return (
        <Form.Item
            label={info.label}
            name={info.key}
            key={key}
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: "Este campo es requerido"
                }
            ]}
        >
            <DatePicker
                format={info && info.format ? info.format : "DD/MM/YYYY"}
                disabledDate={disabledDate}
                disabled={info && info.disabled}
                locale={locale}
                placeholder={moment().format("DD/MM/YYYY")}
                suffixIcon={info && !info.disabled && <DownOutlined />}
                onChange={onChange}
            />
        </Form.Item>
    )
}